export const FullMonthDayYear = 'MMMM Do, YYYY'; // November 20th, 2021
export const MonthDayYearShortSlashed = 'MM/DD/YY'; // 12/30/21
export const MonthDayFullYearSlashed = 'MM/DD/YYYY'; // 01/25/2021
export const MonthDaySlashed = 'MM/DD'; // 01/25
export const MonthDayShortFullYearSlashed = 'M/D/YYYY'; // 1/7/2021
export const MonthDayShortTwoDigitYearSlashed = 'M/D/YY'; // 1/7/21
export const MonthDayFullYearDashed = 'YYYY-MM-DD'; // 2021-25-01
export const MonthDayYearComma = 'MMMM D, YYYY'; // February 4, 2021
export const DayOfWeekMonthDayTime = 'ddd, MMM D, h:mmA'; // WED, APR 13, 8:30AM
export const FullDayOfWeekMonthDayTime = 'dddd MMM D'; // Wednesday, APR 13
export const ShortDayOfWeekMonthDayTime = 'ddd MMM D'; // Wed, APR 13
export const MonthDayTime = 'MMM DD, h:mm a'; // Sep 02, 2:12 pm
export const DayOfWeekMonthDay = 'ddd, MMM D'; // Tue, May 17
export const DayOfWeekDayYear = 'ddd DD, YYYY'; // Tue 17, 2021
export const DayOfWeekMonthDayYear = 'ddd, MMM D, YYYY'; // Tue, May 17, 2021
export const ShortMonthDayYearComma = 'MMM D, YYYY'; // Jan 9, 2022
export const ShortMonthDayFullYearComma = 'MMM DD, YYYY'; // Jan 09, 2022
export const ShortMonthDay = 'MMM D'; // Jan 9
export const ShortMonthYear = 'MMM YYYY'; // Jan 2022
export const MonthDayFullYearDashedWithTimezone = 'YYYY-MM-DD h:mmA Z'; // 2022-03-08 8:30AM +03:00
export const Time12Hour = 'h:mm a'; // 9:12 am
export const Time12HourNoAbbreviation = 'h:mm'; // 9:12
export const Time24HourNoAbbreviation = 'hh:mm'; // 13:12
export const Time24HourAbbreviation = 'hh:mmA'; // 01:12PM
export const FullYear = 'YYYY'; // 1984
export const DaysOfWeekMonthDay = 'ddd, MMM D'; // WED, APR 13
export const FullMonthYear = 'MMMM, YYYY'; // April 1985
export const FullDateAndTime = 'YYYY-MM-DD hh:mm:ss'; // 1954-02-21 23:43:12
export const FullDateAndTime24Hour = 'YYYY-MM-DD HH:mm:ss'; // 1954-02-21 23:43:12
export const TimeMonthDayYear = 'h:mma, M/D/YY'; // 10:43am, 5/4/22
export const TimeMonthDayFullYearNoComma = 'h:mma M/D/YYYY'; // 10:43am 5/4/2022
export const FullDayOfWeekMonthDayYear = 'dddd, MMMM D, YYYY'; // Wednesday, October 13, 2021
export const DayMonthDateCommaYear = 'ddd MMM D, YYYY';
export const FullTime24Hour = 'HH:mm:ss'; // 15:23:12
export const DayOfWeekMonthDayYearShortSlashed = 'ddd MM/DD/YY'; // Tue 31/05/24
export const MonthDayWithoutSeparator = 'MMM DD'; // Oct 23
export const MonthDayYearWithoutSeparator = 'MMM DD YYYY'; // Oct 23 2023
export const MinutesAndSeconds = 'mm:ss'; // 01:30
export const MonthDayCommaTime = 'MMM D, h:mm a'; // Jul 3, 12:30 pm
export const MonthYearShortSlashed = 'MM/YY'; // 12/23
export const DayMonthPipeTime = 'ddd, MMM D | h:mm A';
export const Time24HourAbbreviationLowercase = 'hh:mma'; // 01:12pm CST
export const Time24HourAbbreviationTimezone = 'hh:mma z'; // 01:12pm CST
export const MonthDayYearShortSlashedTime = 'MM/DD/YY, h:mma'; // 12/30/21, 3:03pm
export const MonthDayYearUnderscored = 'M_DD_YYYY'; // 1_25_2021
export const MonthDayYearSlashedTime = 'M/D/YYYY h:mmA'; // 8/15/2024 11:48AM
